
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 12,
    backgroundColor: 'white',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    overflowY: 'auto'
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxHeight: "70%",
    maxWidth: 900,
    backgroundColor: 'transparent',
    [theme.breakpoints.down('md')]: {
        width: '100%',
        padding: '20px',
        margin: '50px 15px'
      },
  },

  cardBody: {
    width: '100%',
    justifyContent: 'space-between',
    padding: '12px 2em',
    backgroundColor: '#F5F5F5',
    boxShadow: "0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)",
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  contentBody: {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 3em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    }
  },

  statusTitle: {
    color: "#000000",
    fontFamily: "Montserrat",
    fontSize: '18px',
    fontWeight: "600",
    paddingLeft: 40,
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px'
    }
  },
 
  content: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: '14px',
    fontWeight: "500",
  },

 iconStyle: {
    color: '#535D6D',
    position: 'absolute',
    top: 4,
    right: 12,
    [theme.breakpoints.down('sm')]: {
      top: 16,
      right: 28
    },
}

}));
